import { highlight, type Lang } from "../_lib/highlight";

/** Code as the docs show it: one row per line, coloured when the page is built (light, like the mock). */
export function CodeLines({ code, lang }: { code: string; lang: Lang }) {
  return (
    <pre className="code" data-lang={lang}>
      <code>
        {highlight(code, lang).map((tokens, i) => (
          <span key={i} className="l">
            {tokens.length === 0
              ? " "
              : tokens.map((t, j) =>
                  t.kind ? (
                    <span key={j} className={`t-${t.kind}`}>
                      {t.text}
                    </span>
                  ) : (
                    t.text
                  )
                )}
          </span>
        ))}
      </code>
    </pre>
  );
}
